/* ============================================================
   BNDT GLOBAL JS
   ============================================================ */

(function() {
  'use strict';

  /* --- Announce Bar Marquee --- */
  function initMarquee() {
    var track = document.querySelector('.announce-bar__track');
    if (!track) return;
    // Clone content for seamless loop
    var items = track.innerHTML;
    track.innerHTML = items + items;
  }

  /* --- Announce Bar Slot Machine (mobile) --- */
  function initAnnounceSlot() {
    var slot = document.getElementById('announce-slot');
    if (!slot) return;
    var items = slot.querySelectorAll('.announce-bar__slot-item');
    if (items.length < 2) return;

    var current = 0;

    setInterval(function() {
      var prev = current;
      current = (current + 1) % items.length;

      // Exit current (roll up and out)
      items[prev].classList.remove('is-active');
      items[prev].classList.add('is-exiting');

      // Enter next (roll up from below)
      items[current].classList.remove('is-exiting');
      items[current].classList.add('is-active');

      // Clean up exiting class after transition
      setTimeout(function() {
        items[prev].classList.remove('is-exiting');
      }, 500);
    }, 3000);
  }

  /* --- Nav Hamburger Toggle --- */
  function initNav() {
    var hamburger = document.querySelector('.site-nav__hamburger');
    var drawer = document.querySelector('.nav-drawer');
    var overlay = document.querySelector('.nav-drawer__overlay');
    if (!hamburger || !drawer) return;

    function toggleNav() {
      var isOpen = drawer.classList.contains('is-open');
      if (isOpen) {
        drawer.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        if (overlay) overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      } else {
        drawer.classList.add('is-open');
        hamburger.classList.add('is-active');
        if (overlay) overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    }

    hamburger.addEventListener('click', toggleNav);
    if (overlay) overlay.addEventListener('click', toggleNav);
  }

  /* --- Sweep Countdown --- */
  function initSweepCountdown() {
    var cdH = document.querySelector('[data-cd="h"]');
    var cdM = document.querySelector('[data-cd="m"]');
    var cdS = document.querySelector('[data-cd="s"]');
    if (!cdH || !cdM || !cdS) return;

    var cdEnd = Date.now() + (2 * 3600 + 47 * 60 + 13) * 1000;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function update() {
      var diff = Math.max(0, cdEnd - Date.now());
      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      cdH.textContent = pad(h);
      cdM.textContent = pad(m);
      cdS.textContent = pad(s);

      if (diff > 0) {
        requestAnimationFrame(function() {
          setTimeout(update, 250);
        });
      }
    }

    update();
  }

  /* --- Cart Count --- */
  function updateCartCount() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var badges = document.querySelectorAll('.site-nav__cart-count');
      badges.forEach(function(badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function() {});
  }

  /* --- Social Proof Toast --- */
  function initSocialProof() {
    var el = document.getElementById('social-proof');
    if (!el) return;

    var names = [
      'Alex M.', 'Jordan T.', 'Chris R.', 'Taylor S.', 'Sam W.',
      'Morgan K.', 'Casey L.', 'Drew P.', 'Jamie H.', 'Riley B.',
      'Matt D.', 'Nick F.', 'Brandon C.', 'Kyle A.', 'Jake N.',
      'Dylan G.', 'Tyler E.', 'Austin J.', 'Ethan V.', 'Luke Z.'
    ];

    var locations = [
      'Los Angeles, CA', 'New York, NY', 'Miami, FL', 'Austin, TX',
      'Chicago, IL', 'Denver, CO', 'Seattle, WA', 'Nashville, TN',
      'Phoenix, AZ', 'Portland, OR', 'San Diego, CA', 'Atlanta, GA',
      'Dallas, TX', 'Charlotte, NC', 'Tampa, FL', 'Boston, MA',
      'Scottsdale, AZ', 'Brooklyn, NY', 'San Francisco, CA', 'Houston, TX'
    ];

    var products = [
      'Maverick Cardholder — Black',
      'Maverick Cardholder — Rich Mahogany',
      'Maverick Cardholder — Miami Blue',
      'Maverick Cardholder — Highlighter',
      "Maverick Cardholder — Lamb O'range",
      'Maverick Cardholder — Vigilante Black',
      'Maverick Cardholder — Vigilante Shark Grey',
      'Maverick Cardholder 2.0 W Grip/Stand — Black Pebble',
      'Maverick Cardholder 2.0 W Grip/Stand — Miami Blue',
      "Maverick Cardholder 2.0 W Grip/Stand — Lamb O'range",
      'Maverick MagSafe Wallet — Black',
      'Maverick MagSafe Wallet — Highlighter',
      'BNDT Smart Tracker Card',
      'Outlaw Cardholder',
      'Slinger Cardholder',
      'The Ranger Carbon Money Clip',
      'Maverick Light Cardholder'
    ];

    var times = [
      '2 minutes ago', '5 minutes ago', '8 minutes ago',
      '12 minutes ago', '15 minutes ago', '20 minutes ago',
      '25 minutes ago', '32 minutes ago', '45 minutes ago'
    ];

    var spName = document.getElementById('sp-name');
    var spLoc = document.getElementById('sp-location');
    var spProd = document.getElementById('sp-product');
    var spTime = document.getElementById('sp-time');
    var hideTimer = null;

    function pick(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function showToast() {
      if (window.location.pathname.indexOf('/cart') !== -1) return;

      spName.textContent = pick(names);
      spLoc.textContent = pick(locations);
      spProd.textContent = pick(products);
      spTime.textContent = pick(times);

      el.classList.add('is-visible');

      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function() {
        el.classList.remove('is-visible');
      }, 6000);
    }

    // First toast after 15s, then every 45s after that
    function scheduleNext() {
      setTimeout(function() {
        showToast();
        scheduleNext();
      }, 45000);
    }

    setTimeout(function() {
      showToast();
      scheduleNext();
    }, 15000);
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function() {
    initMarquee();
    initAnnounceSlot();
    initNav();
    initSweepCountdown();
    updateCartCount();
    initSocialProof();
    initFiveXMode();
    initSweepGeoBlock();
    initExitIntent();
  });

  /* --- Exit Intent Popup --- */
  function initExitIntent() {
    var popup = document.getElementById('exit-popup');
    var overlay = document.getElementById('exit-popup-overlay');
    var closeBtn = document.getElementById('exit-popup-close');
    var timerEl = document.getElementById('exit-timer');
    if (!popup || !overlay) return;

    // Don't show on cart page
    if (window.location.pathname.indexOf('/cart') !== -1) return;

    // Only show once per session
    if (sessionStorage.getItem('bndt_exit_shown')) return;

    var shown = false;
    var armed = false;
    var timerInterval = null;
    var secondsLeft = 300;

    // Arm after 35 seconds on page
    setTimeout(function() { armed = true; }, 60000);

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function startTimer() {
      function tick() {
        var m = Math.floor(secondsLeft / 60);
        var s = secondsLeft % 60;
        if (timerEl) timerEl.textContent = m + ':' + pad(s);
        if (secondsLeft <= 0) {
          clearInterval(timerInterval);
          hidePopup();
        }
        secondsLeft--;
      }
      tick();
      timerInterval = setInterval(tick, 1000);
    }

    function showPopup() {
      if (shown || !armed) return;
      shown = true;
      sessionStorage.setItem('bndt_exit_shown', '1');
      popup.classList.add('is-visible');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      startTimer();
    }

    function hidePopup() {
      popup.classList.remove('is-visible');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      if (timerInterval) clearInterval(timerInterval);
    }

    if (closeBtn) closeBtn.addEventListener('click', hidePopup);
    overlay.addEventListener('click', hidePopup);

    // Desktop: mouse leaves viewport at top
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0) {
        showPopup();
      }
    });

    // Also catch mouseout as backup (some browsers don't fire mouseleave on document)
    document.addEventListener('mouseout', function(e) {
      if (!e.relatedTarget && !e.toElement) {
        showPopup();
      }
    });

    // Mobile: user switches tabs or hits back (visibility change only)
    var wasHidden = false;
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        wasHidden = true;
      }
      if (document.visibilityState === 'visible' && wasHidden) {
        showPopup();
      }
    });
  }

  /* --- 5x Entry Mode --- */
  function initFiveXMode() {
    var expires = parseInt(sessionStorage.getItem('bndt_5x_expires') || '0', 10);
    if (!expires || Date.now() > expires) {
      // Expired or not set — clean up
      sessionStorage.removeItem('bndt_5x_active');
      sessionStorage.removeItem('bndt_5x_expires');
      return;
    }

    // 5x mode is active
    var banner = document.getElementById('five-x-banner');
    var timerEl = document.getElementById('five-x-timer');

    // Show the banner
    if (banner) banner.style.display = 'flex';

    // Countdown timer on the banner
    function updateBannerTimer() {
      var remaining = Math.max(0, expires - Date.now());
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      if (timerEl) timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (remaining <= 0) {
        if (banner) banner.style.display = 'none';
        sessionStorage.removeItem('bndt_5x_active');
        sessionStorage.removeItem('bndt_5x_expires');
        clearInterval(bannerInterval);
        // Reload to reset to 3x
        window.location.reload();
      }
    }
    updateBannerTimer();
    var bannerInterval = setInterval(updateBannerTimer, 1000);

    // Text/entry replacement handled by inline script in theme.liquid (runs on window.load)
    // Set cart attribute so Shopify order carries the multiplier through checkout
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { entry_multiplier: '5' } })
    }).catch(function() {});

    // Expose multiplier globally
    window.BNDT = window.BNDT || {};
    window.BNDT.entryMultiplier = 5;
  }

  /* --- Sweep Geo-Block (NY, FL, RI) --- */
  function initSweepGeoBlock() {
    // Use Shopify's built-in geolocation or a free API
    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var region = (data.region || '').toLowerCase();
        var blocked = ['new york', 'florida', 'rhode island'];
        var isBlocked = blocked.some(function(s) { return region.indexOf(s) !== -1; });

        if (isBlocked) {
          // Hide all sweepstakes entry UI elements
          document.documentElement.classList.add('sweep-geo-blocked');
        }
      })
      .catch(function() {});
  }

  // Expose for other scripts
  window.BNDT = window.BNDT || {};
  window.BNDT.updateCartCount = updateCartCount;

})();
